import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import DateTime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { useState, useRef } from 'react';
import { useGetAvailableLanguages } from '../../hooks/global/Languages';
import { getObjectValue, setNestedValue, setObjectValue, validate } from '../../helpers/general';
import { useUpdateMotivators, useInsertMotivators, useDeleteMotivators } from '../../hooks/motivators/Motivators';
import moment from 'moment';
import { useGetCurrentVendor } from '../../hooks/global/User';


function MotivatorsEditForm({ id, data, onClose, onNew, onUpdate, onSave}) {
    const { t } = useTranslation();
    const availableLan = useGetAvailableLanguages()

    const [motivator, setMotivator] = useState(data);
    const [showGdprInfo, setShowGdprInfo] = useState(false)
    const targetRef = useRef(null);

    const vednor = useGetCurrentVendor();

    const { mutate: update, data: updatedData, isLoading: isUpdateLoading, isError: isUpdateError } = useUpdateMotivators(id)
    const { mutate: insert, data: insertedData } = useInsertMotivators();
    const { mutate: remove, data: removeData } = useDeleteMotivators();

    const [ validateData, setValidateData ] = useState({});

    const validateRules = [
        { index: 'title', regex: /^.+$/s, condition: true },
        { index: 'description', regex: /^.+$/s, condition: true },
        { index: 'start_date', regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, condition: true },
        { index: 'end_date', regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, condition: true },
        { index: 'terms_and_conditions_description', regex: /^.+$/s, condition: true },
        { index: 'terms_and_conditions', regex: /^(https?:\/\/)?([a-z\d.-]+)\.([a-z]{2,6})(\/[\w\d%_.~+-]*)*\/?$/i, condition: true }
    ];

    useEffect(() => {
        if (insertedData) {
            let temp = { ...motivator };
            temp.id = insertedData.id;
            setMotivator(temp)
        }
        if(updatedData) onSave?.();
    }, [insertedData, motivator, validateData, updatedData])

    const handleChange = (e) => {
        if(id !== null && e.index === "type") return;

        let temp = { ...motivator };
        setObjectValue(temp, e.index, e.event.target.value)
        setMotivator(temp);
        
    }

    const handleChangeLng = (e) => {
        let temp = { ...motivator }
        let val = getObjectValue(temp, e.index)

        if(!val){
            val = {};
            setNestedValue(temp, e.index, val);
        }
        val[e.event.target.name] = e.event.target.value;
        setNestedValue(temp, e.index, val)
        setMotivator(temp);
    }

    const handleChangeDate = (e) => {
        try {
            let val = moment(e.event,"YYYY-MM-DDTHH:mm:ss.SSS[Z]", true);//e.event.utc?.();
            if(val.isValid()) {
                let temp = { ...motivator }
                setObjectValue(temp, e.index, val.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));
                setMotivator(temp);
            }
        } catch (error) {
            console.error("Error occurred:", error);
        }
    };
    const handleChangeCheckbox = (e) => {
        let temp = { ...motivator };

        setObjectValue(temp, e.index, e.event.target.checked)
        setMotivator(temp);
    }

    const handleSave = async (e) => {

        const validatorErrors = validate(motivator, validateRules);
        setValidateData(validatorErrors.newValidateData);

        if(!validatorErrors.e){
            motivator.id ? update({ data: motivator, message: t('toast.mo') }) : insert({ data: motivator, message: t('toast.mo') });
            onNew?.();
            onClose?.();
        } else {
            console.info("validation Error", validatorErrors.newValidateData);
        }
    };

    const handleDelete = (e) => {
        remove({ data: id, message: `${t('toast.lad1')} ${t('toast.lad2a')}`});
        onClose?.();

    }

    return (
        <>
            <div ref={targetRef} className="prizeGame-more">

                <div className="langSelectInputWrap langSelectInputWrapSelect">
                    <strong className="unbold">{t("admin.prize.type")}</strong>
                    <span className="breakMobile">
                        <div className="langSelectInput">
                            <input id={"prizeGameType-prizeGame_"+id} type="radio" name={"prizeGameType_"+id} disabled={id ? true:false} checked={motivator.type === "PRIZE_GAME"}
                                value={"PRIZE_GAME"} onChange={(e) => { handleChange({ event: e, index: "type" }) }} />
                            <label htmlFor={"prizeGameType-prizeGame_"+id}>{t("admin.prize.prize")}</label>
                        </div>
                        <div className="langSelectInput">
                            <input id={"prizeGameType-cupon_"+id} type="radio" name={"prizeGameType_"+id}  disabled={id ? true:false} checked={motivator.type === "COUPON"}
                                value={"COUPON"} onChange={(e) => { handleChange({ event: e, index: "type" }) }} />
                            <label htmlFor={"prizeGameType-cupon_"+id}>{t("admin.prize.cupon")}</label>
                        </div>
                    </span>
                </div>


                <div className="langSelectInputWrap">
                    <strong className="unbold">{t("admin.prize.address")}</strong>
                    {availableLan.map(lng => {
                        return (
                            <div className="langSelectInput" key={lng}>
                                <label>{lng}: </label>
                                <div>
                                    <input name={lng} tabIndex="0" value={motivator?.title[lng] ? motivator.title[lng] : ""} onChange={(e) => { handleChangeLng({ event: e, index: "title" }) }} />
                                </div>
                                {getObjectValue(validateData, 'title') === false && <span className="validation">{t("err.req")}</span>}
                            </div>
                        )
                    })
                    }
                </div>

                <div className="langSelectInputWrap">
                    <strong className="unbold">{t("admin.prize.desc")}</strong>
                    {availableLan.map(lng => {
                        return (
                            <div className="langSelectInput" key={lng}>
                                <label>{lng}: </label>
                                <div>
                                    <textarea id={"description_"+id}
                                        value={motivator ? motivator.description[lng] : ""}
                                        name={lng}
                                        rows={4}
                                        cols={40}
                                        tabIndex="0"
                                        onChange={(e) => { handleChangeLng({ event: e, index: "description" }) }}
                                        maxLength="1000" />
                                </div>
                                {getObjectValue(validateData, 'description') === false &&  <span className="validation">{t("err.req")}</span>}
                            </div>
                        );
                    })}
                </div>

                <div className="langSelectInputWrap">
                    <strong className="unbold">{t("admin.prize.val")}</strong>
                </div>
                <div className="langSelectInputWrap langSelectInputWrapDate">
                    <div className="langSelectInputWrapDateWrap">
                        <em>{t("admin.common.from")}: </em>
                        <DateTime className={"this.state.validationErrors.from" ? ("errorOutline") : ("")}
                            name="from"
                            dateFormat="DD.MM.YYYY"
                            closeOnSelect = {true}
                            timeFormat={false}
                            locale="sl_SI"
                            tabIndex="4"
                            onChange={(e) => { handleChangeDate({ event: e, index: "start_date" }) }}
                            value={motivator.start_date ? new Date(motivator.start_date) : ""} />
                    </div>
                    <div className="langSelectInputWrapDateWrap">
                        <em>{t("admin.common.to")}: </em>
                        <DateTime className={"this.state.validationErrors.to" ? ("errorOutline") : ("")}
                            name="to"
                            locale="sl_SI"
                            tabIndex="5"
                            closeOnSelect = {true}
                            dateFormat="DD.MM.YYYY"
                            timeFormat={false}
                            onChange={(e) => { handleChangeDate({ event: e, index: "end_date" }) }}
                            value={motivator.end_date ? new Date(motivator.end_date) : ""} />
                    </div>
                    {(getObjectValue(validateData, 'start_date') === false || getObjectValue(validateData, 'end_date') === false) && 
                        <div style={{color: '#fff', backgroundColor: '#f05228', padding: '3px 5px', display: 'inline-block', marginBottom: '10px'}}>
                            <span className="validator">{t("err.vDate")}</span> &nbsp;
                            <span className="validator">{t("err.dates")}</span>
                        </div>
                    }

                </div>
                <div className="langSelectInputWrap langSelectInputWrapCheckbox">
                    <strong className="unbold">{t("admin.prize.descAns")}</strong>
                    <div className="langSelectInput">
                        <input type="checkbox" tabIndex="0" id={"prizeGameParticipation_"+id}
                            checked={motivator.participation_requirements?.reviewTextWritten ? motivator.participation_requirements.reviewTextWritten : false}
                            onChange={(e) => { handleChangeCheckbox({ event: e, index: "participation_requirements.reviewTextWritten" }) }}
                        />
                        <label htmlFor={"prizeGameParticipation_"+id}>{t("admin.prize.fifteen")}</label>
                    </div>
                </div>


                <div className="langSelectInputWrap langSelectInputWrapGdpr">
                    <strong className="unbold">{t("admin.prize.gdpr")}
                        <span className="gdpr-about" onClick={() => { setShowGdprInfo(!showGdprInfo) }}></span>
                    </strong>
                    {showGdprInfo && (
                        <div className="gdpr-about-more">
                            {availableLan.map(lng => {
                                return (
                                    <p key={lng}><strong>{lng} {t("admin.prize.exa")}:</strong> {t("admin.prize.gdpr1." + lng, { lng: lng })} {vednor.name},&nbsp;
                                        {t("admin.prize.gdpr2." + lng, { lng: lng }) + " "}
                                        {(motivator.type === "PRIZE_GAME")
                                            ? t("admin.prize.gdpr3a." + lng, { lng: lng })
                                            : t("admin.prize.gdpr3b." + lng, { lng: lng })}
                                    </p>
                                )
                            })

                            }
                        </div>
                    )
                    }

                    {motivator.terms_and_conditions_description && availableLan.map(lng => {
                        return (
                            <div className="langSelectInput" key={lng}>
                                <label>{lng}: </label>
                                <div>
                                    <textarea key={lng} tabIndex="0" rows={4}
                                        name={lng}
                                        value={motivator ? motivator.terms_and_conditions_description[lng] : ""}
                                        onChange={(e) => { handleChangeLng({ event: e, index: "terms_and_conditions_description" }) }} />
                                </div>
                                { getObjectValue(validateData, 'terms_and_conditions_description') === false && <span className="validation">{t("err.req")}</span>}
                            </div>
                        );
                    })
                    }
                </div>

                <div className="langSelectInputWrap langSelectInputWrapCheckbox">
                    <div>
                        <div className="langSelectInput">
                            <input type="checkbox" tabIndex="0" id={"gdprPromotionsEnabled_"+id}
                                checked={(motivator && motivator.gdpr_promotions?.enabled) ? motivator.gdpr_promotions.enabled : false}
                                onChange={(e) => { handleChangeCheckbox({ event: e, index: "gdpr_promotions.enabled" }) }} />
                            <label htmlFor={"gdprPromotionsEnabled_"+id}>{t("admin.prize.gdprPromotionsEnabled")}</label>
                        </div>
                    </div>
                </div>

                {(motivator.gdpr_promotions && motivator.gdpr_promotions.enabled) &&
                    <div className="langSelectInputWrap ">
                        <strong className="unbold">{t("admin.prize.promotionsDescription")}</strong>

                        {availableLan.map(lng => {
                            return (
                                <div className="langSelectInput" key={lng}>
                                    <label>{lng}: </label>
                                    <div>
                                        <textarea key={lng} tabIndex="0" rows={4}
                                            name={lng}
                                            value={(motivator && motivator.gdpr_promotions && motivator.gdpr_promotions.checkboxTexts) ? motivator.gdpr_promotions.checkboxTexts[lng] : ""}
                                            onChange={(e) => { handleChangeLng({ event: e, index: "gdpr_promotions.checkboxTexts" }) }} />
                                    </div>
                                </div>
                            );
                        })
                        }
                    </div>
                }

                <div className="langSelectInputWrap langSelectInputWrapUrl">
                    <strong className="unbold">{t("admin.prize.url")}</strong>
                    <div className="langSelectInput">
                        <input name="terms"
                            tabIndex="0"
                            value={motivator ? motivator.terms_and_conditions : ""}
                            onChange={(e) => { handleChange({ event: e, index: "terms_and_conditions" }) }}
                            placeholder="http://www.domain.com/terms"
                        />
                    </div>
                    {/*this.state.validationErrors.termsAndConditions === "req" && <span className="validation">{t("err.req")}</span>*/}
                { getObjectValue(validateData, 'terms_and_conditions') === false && <span className="validation">{t("err.validUrl")}</span>}
                </div>

                <button type="button"
                    className="btn btn-default btn-save"
                    onClick={handleSave}
                    title="Shrani">{t("admin.common.save")}</button>
                {motivator &&
                    <button type="button"
                        className="btn btn-default btn-delete"
                        onClick={handleDelete}
                        title="Izbriši">{t("admin.common.del")}</button>
                }


                <button type="button"
                    className="btn btn-default btn-cancel"
                    onClick={() => { onClose?.() }}
                    title="Close">{t("admin.common.close")}</button>
            </div>
        </>
    )
}

export default MotivatorsEditForm;